// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NumChildren__numChildren____wqPS {
    margin-left: 5px;
    font-weight: normal;
    opacity: 0.5;
    font-size: 11px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numChildren": `NumChildren__numChildren____wqPS`
};
module.exports = ___CSS_LOADER_EXPORT___;
